import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { id } from "./id";

const get = function (params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: Array<{
      chapter: number;
    }>;
  }>("courses/module/chapter/content", {
    params,
  });
};

const post = function (data: { chapter: number }) {
  return api.post("courses/module/chapter/content", data);
};

export const content = {
  get,
  post,
  id,
};
